import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { FieldDifference } from './FieldDifference.js';
export class MismatchDetails extends BaseMessage {
    firstNameMismatch;
    middleNameMismatch;
    lastNameMismatch;
    dateOfBirthMismatch;
}
__decorate([
    Field.message({
        description: 'Change of first name of applicant',
    }),
    __metadata("design:type", FieldDifference)
], MismatchDetails.prototype, "firstNameMismatch", void 0);
__decorate([
    Field.message({
        description: 'Change of middle name of applicant',
    }),
    __metadata("design:type", FieldDifference)
], MismatchDetails.prototype, "middleNameMismatch", void 0);
__decorate([
    Field.message({
        description: 'Change of last name of applicant',
    }),
    __metadata("design:type", FieldDifference)
], MismatchDetails.prototype, "lastNameMismatch", void 0);
__decorate([
    Field.message({
        description: 'Change of date of birth of applicant',
    }),
    __metadata("design:type", FieldDifference)
], MismatchDetails.prototype, "dateOfBirthMismatch", void 0);
//# sourceMappingURL=MismatchDetails.js.map